
import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Submit from "./pages/Submit";
import BusinessDetail from "./pages/BusinessDetail";
import { SearchProvider } from './context/SearchContext';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";

// Create a client
const queryClient = new QueryClient();

function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <SearchProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/submit" element={<Submit />} />
              <Route path="/business/:id" element={<BusinessDetail />} />
            </Routes>
          </BrowserRouter>
        </SearchProvider>
      </QueryClientProvider>
      
      {/* Add Sonner toaster for notifications */}
      <Toaster position="top-right" />
    </>
  );
}

export default App;
